export const AM = {
  font: '"Nunito Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  ink: '#08081B',
  muted: '#63637D',
  disabled: '#7F7F99',
  inverted: '#FFFFFF',
  surface: '#FFFFFF',
  background: '#F6F6F8',
  grey25: '#F6F6F8',
  grey50: '#E3E3E8',
  grey100: '#C1C1CD',
  divider: 'rgba(8, 8, 27, 0.15)',
  actionHover: 'rgba(8, 8, 27, 0.04)',
  actionSelected: 'rgba(8, 8, 27, 0.08)',
  actionActive: 'rgba(8, 8, 27, 0.54)',
  actionDisabled: 'rgba(8, 8, 27, 0.26)',
  actionDisabledBg: 'rgba(8, 8, 27, 0.12)',
  primary: '#2A2A8B',
  primaryContrast: '#FFFFFF',
  indigo50: '#EFEFFA',
  indigo100: '#D4D4F2',
  indigo200: '#A9A9E5',
  indigo300: '#8181D9',
  indigo600: '#2F2F9D',
  red50: '#FFE5E5',
  red200: '#FE8B8B',
  red300: '#FE5858',
  red700: '#B20101',
  red800: '#890101',
  orange300: '#F6A55B',
  success: '#52BB3A',
  scrim: 'rgba(0, 0, 0, 0.5)',
  elevationModal:
    '0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)',
  elevationFloating:
    '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
} as const;

export const AM_TEXT = {
  body1: { fontSize: '16px', lineHeight: '24px', fontWeight: 400 },
  body1Semi: { fontSize: '16px', lineHeight: '24px', fontWeight: 600 },
  body1Bold: { fontSize: '16px', lineHeight: '24px', fontWeight: 700 },
  body2: { fontSize: '12px', lineHeight: '16px', fontWeight: 400 },
  body2Semi: { fontSize: '12px', lineHeight: '16px', fontWeight: 600 },
  body2Bold: { fontSize: '12px', lineHeight: '16px', fontWeight: 700 },
  h4: { fontSize: '20px', lineHeight: '28px', fontWeight: 700 },
  overline: {
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 700,
    letterSpacing: '0.5px',
    textTransform: 'uppercase' as const,
  },
} as const;
